import type { FC } from 'react';
import { Navigate } from 'react-router-dom';
import { EvalConfigController } from '@features/eval-config';
import { useFeatureAccess } from '@hooks/useFeatureAccess';
import { useFeatureFlags } from '@hooks/useFeatureFlags';
import { isSuperadmin } from '@root/helpers/permissions';
import { useUserStore } from '@src/containers/Auth/store';
import withMenuLayout from '@src/layout/withMenuLayout';
import Nav from '@src/routes';

export const EvalConfig: FC = () => {
  const getFeatureFlag = useFeatureFlags();
  const user = useUserStore((state) => state.user);
  const { isLoading: isAccessLoading, pbqaEval: hasPbqaAccess } = useFeatureAccess();
  const isEnabled = getFeatureFlag('EvalConfigs') && isSuperadmin(user) && hasPbqaAccess;

  // Hold rendering while the allowlist check is in flight — redirecting
  // early would bounce allowlisted users to 404 before the answer arrives.
  if (isAccessLoading) {
    return null;
  }

  if (!isEnabled) {
    return <Navigate to={Nav.NotFound} replace />;
  }

  return <EvalConfigController />;
};

export const UserEvalConfigPage = withMenuLayout(EvalConfig);
